<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
import { getTeamsByTeamIds } from '@/api/FirebaseTeamWrapper.js'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
import { getTrees, addTree, getTreeFromTreeId } from '@/api/FirebaseTreesWrapper.js'
import { removeUrl, removeHtml, sortArraybyUpdatedAt } from '@/api/Utilities.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getFirestore, collection, query, onSnapshot, where, orderBy, limit } from 'firebase/firestore'
import * as constant from '@/constant/constant.js'
const db = getFirestore(firebaseApp)

function removUrlFromMsg (trees) {
  let treesArray = []
  if (!trees) { return treesArray }
  for (const tree of trees) {
    if (tree.isDeleted) { continue }
    let data = tree
    data.issue = removeHtml(tree.issue)
    data.issue = removeUrl(data.issue)
    treesArray.push(data)
  }
  return treesArray
}

async function getTreeData (teamId, limitNum) {
  let lastTreeValue
  let treeData
  const indexOptions = {
    targetTeamId: teamId,
    lastTreeValue: lastTreeValue,
    limitNum: limitNum
  }
  ;[treeData, lastTreeValue] = await getTrees('team', indexOptions)
  return removUrlFromMsg(treeData)
}

export default {
  props: ['isInit'],
  data () {
    return {
      DATA_NUM: 15,
      listener: undefined,
      latestTree: undefined,
      oldTree: {id: '', issue: ''},
      userId: '',
      userData: undefined,
      treesMap: new Map(),
      treesData: [],
      path: '',
      isReloading: false,
      isHover: false,
      hoverType: ''
    }
  },
  beforeDestroy () {
    this.listener()
  },
  async created () {
    this.userId = await getMyUserId()
    await this.init()
    // teamが存在しない場合はreturn
    if (this.userData.teams.length === 0) { return }
    // treeのlistenrを作る v9 Moduler
    const QUERY_NUM = 1
    const docRef = collection(db, 'treesV2')
    let q = query(docRef)
    const myTeams = this.userData.teams ? this.userData.teams : []
    q = query(q, where('scope', 'in', myTeams))
    q = query(q, orderBy('updatedAt', 'desc'), limit(QUERY_NUM))
    this.listener = onSnapshot(q, (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.latestTree = doc.data()
        this.latestTree.id = doc.id
        this.latestTree.issue = removeUrl(removeHtml(this.latestTree.issue))
      })
    })
  },
  methods: {
    async init () {
      this.userData = await getMyUserData()
      const teamsOrigin = await getTeamsByTeamIds(this.userData.teams)
      // teamが存在しない場合はreturn
      if (this.userData.teams.length === 0) { return }
      const teams = sortArraybyUpdatedAt(teamsOrigin)
      this.treesMap = new Map()
      let targetTeam = null
      if (this.$route.params.treeId) {
        const tree = await getTreeFromTreeId(this.$route.params.treeId)
        if (tree) {
          this.path = this.$route.path
          targetTeam = tree.scope
        } else {
          targetTeam = teams[0].id
        }
      } else {
        targetTeam = teams[0].id
      }
      for (const team of teams) {
        // 削除済みのTeamならcontinue
        if (team.isDeleted) { continue }
        let treeData = []
        const isDefaultTeam = (team.id === targetTeam)
        if (isDefaultTeam) {
          treeData = await getTreeData(team.id, this.DATA_NUM)
        }
        const teamData = {name: team.teamName, isShow: isDefaultTeam, trees: treeData}
        this.treesMap.set(team.id, teamData)
      }
      this.treesData = Array.from(this.treesMap)
    },
    async pullDown (teamId, option) {
      this.treesMap.forEach(async (value, key) => {
        if (key === teamId) {
          let teamData = this.treesMap.get(teamId)
          if (teamData.trees.length === 0) {
            teamData.trees = await getTreeData(teamId, this.DATA_NUM)
            this.treesMap.set(teamId, teamData)
          }
          if (option === 'force') {
            value.isShow = true
          } else {
            value.isShow = !value.isShow
          }
        } else {
          value.isShow = false
        }
      })
    },
    async reload () {
      this.isReloading = true
      await this.init()
      this.isReloading = false
    },
    cancelTreeBar () {
      this.$emit('cancelTreeBar', false)
    },
    async makeTree (teamId) {
      const issue = constant.DEFAULT_ROOT_MSG
      const treeRef = await addTree(issue, 50, teamId)
      Router.push('/tree/' + treeRef.id)
    },
    mouseOver (index) {
      this.isHover = true
      this.hoverType = index
    },
    mouseLeave () {
      this.isHover = false
      this.hoverType = ''
    }
  },
  watch: {
    isInit: async function (val) {
      // 初期化前ならreturn
      if (!this.isInit) { return }
      await this.init()
      // すでにlistnerがある場合は一旦削除して再度listnerを貼る
      if (this.listner) {
        this.listner()
      }
      // treeのlistenrを作る v9 Moduler
      const QUERY_NUM = 1
      const docRef = collection(db, 'treesV2')
      let q = query(docRef)
      const myTeams = this.userData.teams ? this.userData.teams : []
      q = query(q, where('scope', 'in', myTeams))
      q = query(q, orderBy('updatedAt', 'desc'), limit(QUERY_NUM))
      this.listener = onSnapshot(q, (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.latestTree = doc.data()
          this.latestTree.id = doc.id
          this.latestTree.issue = removeUrl(removeHtml(this.latestTree.issue))
        })
      })
    },
    async $route (to, from) {
      // ハイライト用にpathを保持
      this.path = to.path
      if (to.name === 'Tree') {
        const tree = await getTreeFromTreeId(to.params.treeId)
        const mapData = this.treesMap.get(tree.scope)
        if (!mapData) {
          await this.init()
        } else {
          await this.pullDown(tree.scope, 'force')
        }
      }
    },
    latestTree: {
      handler: async function (val) {
        // データ更新途中発火防止
        if (!this.latestTree.createdAt) { return }
        // 多重発火防止
        if (this.oldTree.id === this.latestTree.id && this.oldTree.issue === this.latestTree.issue) { return }
        // oldTreeの更新
        this.oldTree.id = this.latestTree.id
        this.oldTree.issue = this.latestTree.issue
        this.isReloading = true
        let mapData = this.treesMap.get(this.latestTree.scope)
        if (!mapData) {
          // teamが存在しない
          await this.init()
        } else {
          const targetIndex = mapData.trees.findIndex(tree => tree.id === this.latestTree.id)
          if (targetIndex !== -1) { // mapDataの中にすでにTreeが存在する
            if (!this.latestTree.isDeleted) { // Tree削除flagが立っていない
              mapData.trees[targetIndex].issue = this.latestTree.issue
              const temp = mapData.trees[targetIndex]
              mapData.trees.splice(targetIndex, 1) // 指定配列の削除
              mapData.trees.unshift(temp) // 先頭に削除配列の追加
              this.treesMap.set(this.latestTree.scope, mapData)
              this.treesData = Array.from(this.treesMap)
            } else { // Tree削除flagが立っている
              mapData.trees = await getTreeData(this.latestTree.scope, this.DATA_NUM)
              this.treesMap.set(this.latestTree.scope, mapData)
              this.treesData = Array.from(this.treesMap)
            }
          } else { // mapDataの中にTreeが存在しない場合
            if (!this.latestTree.isDeleted) { // Tree削除flagが立っていない
              if (this.treesMap.get(this.latestTree.scope).trees.length !== 0) { // pull down展開済み
                const treeData = await getTreeData(this.latestTree.scope, 1)
                mapData.trees.unshift(treeData[0])
                if (mapData.trees.length >= this.DATA_NUM) {
                  mapData.trees.splice(-1, 1)
                }
                this.treesMap.set(this.latestTree.scope, mapData)
                this.treesData = Array.from(this.treesMap)
              }
            } else { // Tree削除flagが立っている
              // mapDataは更新しない
            }
          }
        }
        this.isReloading = false
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.team {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  border-top: 1.0px solid rgba(220, 220, 220, 0.5);
}
.trees {
  overflow-wrap: break-word;
  margin-left: 1.4rem;
}
.tree {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  padding-left: 0.4rem;
}
.board {
  margin-top: 0.4rem;
}
.maketree {
  margin-top: 0.4rem;
}
.is-pullup{
  color: #000;
  cursor: pointer;
  cursor: hand;
}
.is-pulldown {
  color: #000;
  cursor: pointer;
  cursor: hand;
}
.add-tree {
  cursor: pointer;
  cursor: hand;
}
.add-hover:hover {
  background-color: #dbdbdb;
}
.markdown {
  background-color: #dbdbdb;
  border-radius: 0.2rem;
}
.is-paddingtop {
  padding-top: 0.75rem;
  padding-bottom: 0.0rem;
  padding-left: 0.375rem;
  padding-right:0.375rem;
}
.is-size-7-1 {
  font-size: .85rem!important;
}
.is-size-8 {
  font-size: 0.55rem !important;
}
.toast {
  margin-top: 0.5rem;
  background-color: #000;
  padding: 0.2rem 0.8rem;
  border-radius: 0.5rem;
  position: absolute;
  z-index: 5;
}
.bd-categories .columns .column {
  overflow: unset;
}
</style>
<template>
  <div class="treebar">
    <nav class="bd-docs-nav">
      <nav class="bd-categories has-text-left">
        <!-- Treeの更新 -->
        <div class="columns is-multiline is-mobile is-marginless">
          <div class="column is-paddingless is-half">
            <div class="buttons">
              <button class="button is-small" @click="reload()" v-if="!isReloading">
                <span class="icon is-small">
                  <i class="fa-solid fa-redo-alt"></i>
                </span>
                <span>更新</span>
              </button>
              <button class="button is-small is-link is-loading" v-else>Loading</button>
            </div>
          </div>
          <div class="column is-paddingless is-half">
            <div class="buttons has-addons is-right">
              <button class="delete" @click="cancelTreeBar()">
              </button>
            </div>
          </div>
        </div>
        <!-- Treeの表示 -->
        <div class="team has-text-weight-bold is-size-7-1" v-for="[teamId, team] in treesData" :key="teamId">
          <!-- Team名の表示 -->
          <div class="columns is-multiline is-mobile is-marginless is-pullup" v-bind:class="{'is-pulldown' : team.isShow}">
            <div @click="pullDown(teamId, null)" class="column is-paddingless is-10">
              <span class="icon" v-if="!team.isShow"><i class="fa-solid fa-caret-right"></i></span>
              <span class="icon" v-else><i class="fa-solid fa-caret-down"></i></span>
              {{team.name}}
              <br>
            </div>
            <div class="column is-paddingless is-2 has-text-right"
            v-on:mouseover="mouseOver(teamId)" v-on:mouseleave="mouseLeave()">
              <router-link class="router has-text-dark" v-bind:to="{ path: '/editteam/' + teamId }" >
                <span class="icon add-hover"><i class="fa-solid fa-ellipsis-v"></i></span>
              </router-link>
              <div class="toast has-text-white is-dark is-size-8" v-if="isHover && hoverType===teamId">
                <p>チームを管理</p>
              </div>
            </div>
          </div>
          <!-- ボードの表示 -->
          <div class="board" v-show="team.isShow">
           <div v-if="path === '/board/' + teamId" class="markdown">
              <router-link v-bind:to="{ path: '/board/' + teamId }">
                <span class="icon"><i class="fa-solid fa-clipboard-list"></i></span>
                <span class="text has-text-weight-bold is-size-7">クリップボード</span>
              </router-link>
            </div>
            <div v-else>
              <router-link v-bind:to="{ path: '/board/' + teamId }">
                <span class="icon"><i class="fa-solid fa-clipboard-list"></i></span>
                <span class="text has-text-weight-bold is-size-7">クリップボード</span>
              </router-link>
            </div>
          </div>
          <!-- ツリーの追加 -->
          <div class="maketree" v-show="team.isShow">
            <div class="columns is-multiline is-mobile is-marginless">
              <div class="column is-paddingless is-8">
                <span class="icon"><i class="fa-solid fa-sitemap"></i></span>
                <span class="text has-text-weight-bold is-size-7">Tree</span>
              </div>
              <div class="column is-paddingless is-4 has-text-right"
              v-on:mouseover="mouseOver('tree')" v-on:mouseleave="mouseLeave()">
                <div class="add-tree" @click="makeTree(teamId)">
                  <span class="icon add-hover"><i class="fa-solid fa-plus"></i></span>
                </div>
                <div class="toast has-text-white is-dark is-size-8" v-if="isHover && hoverType==='tree'">
                  <p>Treeを新規作成</p>
                </div>
              </div>
            </div>
          </div>
          <!-- ツリーの表示 -->
          <div class="trees is-size-8" v-for="tree in team.trees" :key="tree.id" v-show="team.isShow">
            <div class="tree markdown" v-if="path === '/tree/' + tree.id">
              <router-link v-bind:to="{ path: '/tree/' + tree.id}">
                {{tree.issue}}
              </router-link>
            </div>
            <div class="tree" v-else>
              <router-link v-bind:to="{ path: '/tree/' + tree.id}">
                {{tree.issue}}
              </router-link>
            </div>
          </div>
          <!-- ツリー履歴に飛ぶ -->
          <div class="trees is-size-8" v-show="team.isShow">
            <div class="tree">
              <router-link v-bind:to="{ path: '/', query: { team: teamId} }">
                #過去ツリーを見る
              </router-link>
            </div>
          </div>
        </div>
      </nav>
    </nav>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/globals/treebar/TreeBar.vue